import { Component, OnInit } from '@angular/core';
import { MonitoramentoService } from './services/insights/monitoramento.service';

@Component({
  selector: 'app-body',
  templateUrl: './app.component.html'
})
export class AppComponent {
  constructor(private _monitoramentoService: MonitoramentoService) { }
}
